// Hide Empty Product dimensions

document.querySelectorAll('.product-dimension-tabs .pd-tab').forEach(function(tab) {
  const value = tab.querySelector('.value');
  if (!value || value.textContent.trim() === '') {
    tab.style.display = 'none';
  }
});


// Promotion offer card scroll on drag

const container = document.querySelector('.promotion-offers-inner');
const cards = container.querySelectorAll('.promotion-offer');

let isDown = false;
let startX;
let scrollStart;
let cardWidth = cards[0].offsetWidth;

container.addEventListener('mousedown', (e) => {
  isDown = true;
  container.classList.add('dragging');
  startX = e.pageX;
  scrollStart = container.scrollLeft;
});

container.addEventListener('mouseup', (e) => {
  if (!isDown) return;
  isDown = false;
  container.classList.remove('dragging');

  const delta = e.pageX - startX;

  if (Math.abs(delta) > cardWidth / 4) {
    // Scroll one card
    const direction = delta > 0 ? -1 : 1;
    const newScroll = scrollStart + direction * cardWidth;
    container.scrollTo({ left: newScroll, behavior: 'smooth' });
  } else {
    // Snap back
    container.scrollTo({ left: scrollStart, behavior: 'smooth' });
  }
});

container.addEventListener('mousemove', (e) => {
  if (!isDown) return;
  e.preventDefault();
  const x = e.pageX;
  const walk = x - startX;
  container.scrollLeft = scrollStart - walk;
});

container.addEventListener('mouseleave', () => {
  if (!isDown) return;
  isDown = false;
  container.classList.remove('dragging');
  container.scrollTo({ left: scrollStart, behavior: 'smooth' });
});
